import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;
// // var TOGETHER_BASE_URL = `https://togetherapi.dangyoung.com`;
// // var TOGETHER_BASE_URL = "http://192.168.0.10:8000";    // DangYoung_5G
// // var TOGETHER_BASE_URL = "http://10.110.151.195:8000";  // FASTFIVE_5F_5G
// let TOGETHER_BASE_URL = "http://10.110.150.170:8000"; // FASTFIVE_5F_5G

/**
 * 피드, 피드 디테일, 미션글, 소통
 * @param param
 * @returns {Promise<never>}
 */
const getCategoryList = async (param) => {
	const { data } = await axios.get(
		`${baseUrl}/longlife/mission/category/list/together`,
		{
			params: param,
		}
	);
	return data;
};

/**
 * 인플루언서별 매일건강 글 목록 조회 - ksb
 * @param param.offset
 * @param param.pageSize
 * @param param.contentType
 * @param param.influencerId
 * @param param.categoryId
 * @param param.userId
 * @returns {Promise<never>}
 */
const getContentList = async (param) => {
	const { data } = await axios.get(
		`${baseUrl}/longlife/mission/listByTogether`,
		{
			params: param,
		}
	);
	return data;
};

/**
 * 아이디로 글 정보 단건 조회 - ksb
 * @param param
 * @returns {Promise<never>}
 */
const getContent = async (param) => {
	const { data } = await axios.get(`${baseUrl}/longlife/mission/readOne`, {
		params: param,
	});
	return data;
};

/**
 * 매일건강 글 등록 - ksb
 * @param param id, category_id, content_type, thumbnail_img_type, title, sub_title, content, caution, use_pedometer, push_content, ad_push_content, is_best, is_reservation, reservation_date, repeat_time, repeat_type, period_time, period_type, created_by
 * @returns {Promise<*>}
 */
const createContent = async (param) => {
	const { data } = await axios.post(
		`${baseUrl}/longlife/mission/create`,
		param
	);
	return data;
};

/**
 * 매일건강 글 삭제하기 - ksb
 * @param param missionId, userId
 * @returns {Promise<never>}
 */
const deleteContent = async (param) => {
	const { data } = await axios.delete(
		`${baseUrl}/longlife/mission/deleteByTogether`,
		{
			params: param,
		}
	);
	return data;
};

/**
 * 매일건강 글 내용의 첨부되는 이미지 목록 처리 - ksb
 * @param param id, target_type(mission/community/feed/feedDetail/verification/comment/reply), created_by, imageList
 * @returns {Promise<*>}
 */
const registerContentImageList = async (param) => {
	const { data } = await axios.post(
		`${baseUrl}/longlife/mission/image/register`,
		param
	);
	return data;
};

/**
 * 인증글 목록 조회하기 For Admin
 * @param param
 * @returns {Promise<never>}
 */
const adminReadVerification = async (param) => {
	const { data } = await axios.get(
		`${baseUrl}/longlife/mission/verification/admin/together/list`,
		{
			params: param,
		}
	);
	return data;
};

/**
 * 인증글 삭제하기 By Admin
 * @param param
 * id
 * userId
 * influencerId
 * isApp
 * @returns {Promise<never>}
 */
const deleteVerificationByAdmin = async (param) => {
	const { data } = await axios.delete(
		`${baseUrl}/longlife/mission/verification/admin/delete`,
		{
			params: param,
		}
	);
	return data;
};

/**
 * 앱의 미션 인증글에 대한 답글 등록/수정
 * @param param
 * @param param.id - 수정 시 적용
 * @param param.mission_id
 * @param param.verification_id
 * @param param.content
 * @param param.is_app
 * @param param.is_influencer
 * @param param.created_by
 * @param param.img_type
 * @param param.channel_id - 전문가 페이지에만 적용
 * @returns {Promise<*>}
 * 1) 400: 등록하기에 부족한 데이터가 있음
 * 2) 997: 유효하지 않은 사용자
 * 3) 406: 답글 등록 오류
 */
const registerReplyForApp = async (param) => {
	const { data } = await axios.post(
		`${baseUrl}/longlife/mission/reply/register`,
		param
	);
	return data;
};

/**
 * 앱의 미션 인증글에 대한 답글 삭제
 * @param param
 * id
 * userId
 * influencerId
 * isApp
 * @returns {Promise<never>}
 * 1) 400: 삭제하기에 부족한 데이터가 있음
 * 2) 406: 답글 삭제 오류
 */
const deleteReplyByAdmin = async (param) => {
	const { data } = await axios.delete(
		`${baseUrl}/longlife/mission/reply/admin/delete`,
		{
			params: param,
		}
	);
	return data;
};

const longlifeApi = {
	getCategoryList,
	getContentList,
	getContent,
	createContent,
	deleteContent,
	registerContentImageList,

	adminReadVerification,
	deleteVerificationByAdmin,
	registerReplyForApp,
	deleteReplyByAdmin,
};

export default longlifeApi;
